export default {"src":"/_next/static/media/twitch-logo.6b4cfa62.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};